import clone from 'clone';

import SafeList from '../lib/safe-list';

class SLInterface {

    constructor() {
        this.preReady = false;
        this.ready = false;
        this.onConnectCalled = false;
        this.sharedNotificationCenter = null;
        this.NotificationName = {};
        this.sharedInterface = null;
        this.Module = null;

        //
        this.connectCallbacks = new SafeList();

        this.onInitialized = this.onInitialized.bind(this);

        //
        if(typeof(Module) === 'undefined')    {
            return;
        }

        this.sharedNotificationCenter = sharedNotificationCenter;
        this.NotificationName = NotificationName;
        this.Module = Module;
        
        this.preReady = true;

        if(this.Module.statusManager.isInitialized()) {
            this.onInitialized();
            return;
        }

        this.sharedNotificationCenter.register(this.NotificationName.initialized, this.onInitialized);
    }

    register(callback) {
        this.connectCallbacks.addUnique(callback);
    }

    unregister(callback) {
        this.connectCallbacks.remove(callback);
    }

    onInitialized() {
        this.ready = true;
        this.sharedInterface = Module.sharedInterface;

        this.connectCallbacks.forEach((callback) => callback(this));
        this.onConnectCalled = true;

        this.sharedNotificationCenter.unregister(this.NotificationName.initialized, this.onInitialized);
    }

    isPreReady()   {
        return this.preReady;
    }

    isReady()   {
        return this.ready;
    }

    isOnConnectCalled()   {
        return this.onConnectCalled;
    }

    printCallbackListAnalytics()    {
        let numConnectCallbacks = this.connectCallbacks.size();
        console.log('sl-interface ' + ' callbacks: ' + numConnectCallbacks);
    }

    printAnalytics(extended)    {
        this.printCallbackListAnalytics();
        if(this.sharedNotificationCenter)   this.sharedNotificationCenter.printAnalytics(extended);
    }

    updateModuleConfig(config)  {
        if(!this.isPreReady() || !config)    return;

        if(typeof(this.Module.config) !== 'object')   this.Module.config = {};
        
        this.Module.config.flags = Array.isArray(config.flags) ? clone(config.flags) : undefined;
    }

    startUp()   {
        if(!this.isPreReady() || typeof(startUp) !== 'function')  return;

        this.updateModuleConfig(config);
        startUp();  // calls the emscripten Module startUp method defined in app/oe/startUp.js, in this context the Module is defined in app/sl/module.js of the licensing service
    }
};

export let slInterface = new SLInterface();